/**
 * Polyfills the `Element.prototype.closest` function if not available in the browser.
 *
 * @return {Function} A function that will return the closest element, by selector, to this element.
 */
function polyfillClosest() {
  if (Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    Element.prototype.closest = function(s) {
      let el = this;

      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

  return function(element, selector) {
    return element instanceof Element ? element.closest(selector) : null;
  };
}

export const closest = polyfillClosest();
